import authContext from "jwt_context&axios/authContext";
import { useContext } from "react";
import { useGetUserProfileQuery } from "store/apis/profile";

export const useAuth = () => {
  const { authtoken: data } = useContext(authContext);

  return data;
};
